export default __webpack_public_path__ + "static/media/App-Store.6c17800f.svg";